import { apiCaller } from '@/api/apiCaller';
import { ISystem } from '@/modules/system/models';
import { apihost } from '@/api/urls';

const getAll = () => apiCaller.get('/system/', apihost);
const addSystem = (system: ISystem) => apiCaller.post('/system/save', apihost, system);
const updateSystem = (system: ISystem) => apiCaller.put('/system/update', apihost, system);

export const systemApi = {
    getAll,
    addSystem,
    updateSystem,
};
